import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { intl } from "LocaleWrapper";
import { VatRelation } from "__generated__/enums";

const VatCodeAllocationSelect = ({ ...rest }: Omit<SelectProps<VatRelation, false>, "fetchOptions" | "paginated" | "disableSearch">) => {
	return (
		<Select
			{...rest}
			fetchOptions={[ VatRelation.BothInNation, VatRelation.BothInsideEu, VatRelation.World, VatRelation.None ]}
			getOptionLabel={option => intl.formatMessage({ id: `ALLOCATION_${option}` })}
			disableSearch />
	);
};

export default VatCodeAllocationSelect;
